module.exports = __webpack_public_path__ + "static/img/index-on.6506a415.png";